import { helper } from '@ember/component/helper';
import { _hyphenate } from 'scaleflow/utils/hyphenate';

export default helper(function hyphenate([string]) {
  return _hyphenate(string);
});
